export const ACCESSIBLE_CONTEXTS = 'accessibleContexts';
export const CONTEXT_OWNERS = 'owners';
